require './vendor_modules/jquery.bullseye-1.0.js'
require './vendor_modules/last-minute-modal.js'
require '../../modules/doubleclick/frontend/dfp_ads.coffee'
urlUtils = require '../../modules/shared/frontend/url-utils.coffee'
paginationCard = require '../../modules/shared/frontend/pagination-card.coffee'
cardUI = require 'grpn-card-ui/lib/frontend/init'
Filtering = require '../../modules/shared/frontend/filtering.coffee'

# On ready, add JS class
(($) ->

  pageConfig = {}

  if $?
    $(document).ready ->
      $(".primary-nav .Occasion").addClass "active"
      BOOMR["app_name"] = "{{appName}}"
      $('body').removeClass 'no-js'
      positionInAppMessages()
      pageConfig = Groupon.Utils.getConfigFromDom()

      if $(".main.row.module.giftable").is('*') # WARNING: unlike most events, enterviewport will fire synchronously - any error will prevent additional listeners from being attached and hault this init function
        $("#category-deals:not(.dont-load) [data-deal-type]").bind('enterviewport', loadThemeDeals).bullseye()
      if window.location.href.indexOf('show-gift-modal=true') > 5
        showLastMinuteModal()

      createFacetArea() # web template does not provide this, create one!

      Filtering.init pageConfig, true, '', ()->
        # filtering init completed
        setTimeout initAtEnd, 0

  initAtEnd = () ->
    Filtering.initCui()
    setupSidebarToggles()
    Groupon.Performance.pageReady() # should always call this last

  createFacetArea = () ->
    $dest = $("#sidebar-lists .gift-sidebar li.selected");
    classes = 'indent'
    mode = 'appendTo'
    if not $dest.length
      $dest = $('#fallback-facet-area')
      classes = 'standalone'
      mode = 'insertAfter'
    if $dest.length
      $liHolder = $('<ul id="facet-filters" class="'+classes+' nav-facets gift-sidebar"></ul>').hide()
      $liHolder[mode]($dest)

  setupSidebarToggles = () ->
    $('#sidebar-toggle').removeClass('hide-narrow').find('button').on('click', toggleSidebar)
    $('#sidebar-lists-overlay').on('mousedown', toggleSidebar)
    $('#sidebar-lists .close-x').on('mousedown', toggleSidebar)

  hideSidebar = (ev) ->
    if ev.keyCode == 27
      toggleSidebar()

  toggleSidebar = () ->
    $btn = $('#sidebar-toggle button')
    $sidebar = $('#sidebar-lists')
    $overlay = $('#sidebar-lists-overlay')
    cls_expanded_btn = 'btn'
    cls_colapsed_btn = 'btn-invert'
    cls_show_sheet = 'show'
    cls_footer_glow = 'ls-footer-glow'
    shown = $sidebar.hasClass(cls_show_sheet)
    if shown
      $btn.removeClass(cls_expanded_btn).addClass(cls_colapsed_btn)
      $sidebar.removeClass(cls_show_sheet)
      $overlay.removeClass(cls_show_sheet)
      $('body').removeClass cls_footer_glow
      $('body').off('keyup', hideSidebar)
    else
      $btn.removeClass(cls_colapsed_btn).addClass(cls_expanded_btn)
      $sidebar.addClass(cls_show_sheet)
      $overlay.addClass(cls_show_sheet)
      $('body').addClass cls_footer_glow
      $('body').on('keyup', hideSidebar)

  hideThemeRow = (dealRow) ->
    $(dealRow).prev().css({display:'none'})
    $(dealRow).css({display:'none'})
    $(window).trigger("scroll")

  loadThemeDeals = ()->
    dealRow = this
    if dealRow
      resultNodes = $(".deal-card", dealRow)
      query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes($(dealRow), pageConfig)
      $(dealRow).unbind('enterviewport', loadThemeDeals)
      $.ajax
        url: "/occasion/deals-json?#{query_filter_string}&limit=#{resultNodes.length}"
        dataType: "json"
        timeout: 5000
        success: (json) ->
          cards = Filtering.cardsForResp json
          if cards
            $(dealRow).removeClass('deal-load')
            r = 0
            rl = cards.length
            nl = resultNodes.length
            if rl < nl
              hideThemeRow(dealRow)
            else
              totalDeals =  if json and json.pagination and json.pagination.count then json.pagination.count else ''
              $(dealRow).parent('.row.pad-row').find('.view-all').text(I18n.pluralize(totalDeals-0, 'js.modules.merchandising_occasions.see_all_deals_link'))
              while r < rl and r < nl
                dealData = Filtering.dataForDeal cards[r]
                cardHtml = Filtering.htmlForDeal cards[r]
                if cardHtml
                  newCard = $(cardHtml)
                  $(resultNodes[r]).closest('li').replaceWith(newCard)
                r++
              Groupon.Utils.lazyLoadImages()
              GIG.Utils.truncateElements(dealRow)
              Filtering.getCardUi().init($('.card-ui').not('.is-initialized'))

        error: ->
          hideThemeRow(dealRow)

  positionInAppMessages = ()->
    $inapp = $('#ls-in-app-messages')
    dest = $('#ls-banner-holder')
    if $inapp.length
      if dest.length
        dest.append($inapp)
      else if $('.giftable-secondary').length
        $inapp.css({display:'block'})
      else
        dest = $('.standard.new .deal-card')[2] || $('.standard .deal-card')[1] || $('.events-page .deal-card')[5]
        $dest = $(dest).parent('li')
        dest = $dest[0]
        if dest
          $newLi = $(document.createElement('li'))
          $newLi.css
            width: '100%'
            height: 'auto'
          $newLi.insertAfter($dest)
          $newLi.append($inapp)
      if dest
        $inapp.css({display:'block'})
      $inapp.on("click", ".hide-link", () -> $inapp.slideUp())

) $ ? null
